import { Injectable } from "@angular/core";
import { AuthService } from "app/core/auth.service";
import { environment } from "environments/environment";
import { BehaviorSubject, map, Observable, of, tap } from "rxjs";
import { IUserProfile } from "./user-profile";

@Injectable()
export class UserProfileService {
  private readonly userProfile = new BehaviorSubject<IUserProfile>(null);
  public userProfile$: Observable<IUserProfile>;

  constructor(private authService: AuthService) {
    this.userProfile$ = this.userProfile.asObservable();
  }

  getUserProfileFromEvents(): Observable<IUserProfile> {
    if (environment.oauthParameter.mocked.active) {
      const userProfile = {
        userName: "CGSNCM1",
        name: "name",
        firstName: "",
        lastName: "",
        email: "",
      };
      this.userProfile.next(userProfile);
      return this.userProfile$;
    }
    return this.authService.userProfileLoaded().pipe(
      map((claims) => ({
        userName: claims["user_name"],
        name: claims["name"],
        firstName: claims["given_name"],
        lastName: claims["family_name"],
        email: claims["email"],
      })),
      tap((userProfile: IUserProfile) => this.userProfile.next(userProfile)),
    );
  }
}
